import React from 'react';

//Leave footer empty for now
export default function Footer() {
  return <footer></footer>;
}
